var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "metadata-entity-form",
      "data-test": "outside-vif"
    }
  }, [_vm.associatedNodeTitle ? _c('h2', {
    attrs: {
      "id": "chemical-type-title"
    }
  }, [_vm._v("\n    For: " + _vm._s(_vm.associatedNodeTitle) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.submitMetadata
    }
  }, [_vm._l(_vm.bundleFieldsSorted, function (fieldData) {
    return _c('div', {
      key: fieldData.field_name
    }, [_vm.renderField(fieldData.field_name) ? _c('entity-form-field', {
      attrs: {
        "field-data": fieldData,
        "parent-value": _vm.formData[fieldData.field_name],
        "entity-type": "raft_metadata",
        "bundle": _vm.getMetadataType,
        "placeholder": _vm.getPlaceholder(fieldData.field_name),
        "add-class": _vm.addClass
      },
      on: {
        "disable-form-submit": function ($event) {
          _vm.submitDisabled = true;
        },
        "form-error-message": _vm.catchFormError,
        "update-uploading-status": _vm.updateUploadingStatus,
        "update-form-data": _vm.updateFormData
      }
    }) : _vm._e()], 1);
  }), _vm._v(" "), _c('b-form-row', [_c('b-button', {
    attrs: {
      "id": "raft-add-metadata",
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.disableSubmit
    }
  }, [_vm._v("\n        Submit\n      ")])], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }